import React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import { down } from 'styled-breakpoints';

import Loading from '../loading';
import Modal from '../modal';
import * as CDModal from './';

export default function CustomerDetailsModal({
  onConfirm = () => {},
  showTmoForBusiness = false,
}) {
  const [modalContents, setModalContents] = React.useState('LOADING');
  const [contentsIndex, setContentsIndex] = React.useState(0);

  const {
    contact: {
      customerDetailsLoading = false,
      customerDetailsPreloaded = false,
      customerDetailsError = '',
      msisdn = '',
    },
    group: {
      allowSubmit = true,
      hasActiveProtectionPlan = false,
      assurantIneligibleRepair = false,
    },
    settings: SETTINGS,
    dynamicContent: { showCustomerLookup },
    pageText: {
      customerDetails: { title },
    },
  } = Redux.useSelector(state => state);

  const DETAILS_FETCHED_SUCCESS =
    !customerDetailsLoading &&
    customerDetailsPreloaded &&
    !customerDetailsError &&
    allowSubmit;

  const handleOnConfirm = () => {
    if (
      contentsIndex === 0 &&
      showTmoForBusiness &&
      SETTINGS.enableTmoForBusinessModal
    ) {
      setContentsIndex(contentsIndex + 1);
    } else {
      onConfirm();
    }
  };

  const CONTENTS = {
    LOADING: {
      component: Loading,
      title: title.loading,
    },
    NO_MSISDN: {
      component: CDModal.NoMsisdn,
      title: title.noMsisdn,
    },
    DETAILS_FETCHED: {
      component: CDModal.DetailsFetched,
      title: title.detailsFetched,
    },
    UNABLE_TO_VERIFY: {
      component: CDModal.UnableToVerify,
      title: title.unableToVerify,
    },
    DEVICE_INELIGIBLE: {
      component: CDModal.DeviceIneligible,
      title: title.deviceIneligible,
    },
    DIAGNOSTIC: {
      component: CDModal.Diagnostic,
      title: title.diagnostic,
    },
    TMO_FOR_BUSINESS: {
      component: CDModal.TmoForBusiness,
      title: title.tmoForBusiness,
    },
  };

  // modal contents control
  React.useEffect(() => {
    if (!msisdn) {
      setModalContents('NO_MSISDN');
    }
    if (customerDetailsLoading) {
      setModalContents('LOADING');
    }
    if (customerDetailsError) {
      setModalContents('UNABLE_TO_VERIFY');
    }
    if (!allowSubmit && !hasActiveProtectionPlan) {
      setModalContents('DEVICE_INELIGIBLE');
    }
    if (assurantIneligibleRepair || (!allowSubmit && hasActiveProtectionPlan)) {
      setModalContents('DIAGNOSTIC');
    }
    if (DETAILS_FETCHED_SUCCESS) {
      setModalContents('DETAILS_FETCHED');
    }
    if (contentsIndex === 1 && showTmoForBusiness) {
      setModalContents('TMO_FOR_BUSINESS');
    }
  }, [
    allowSubmit,
    contentsIndex,
    customerDetailsError,
    customerDetailsLoading,
    hasActiveProtectionPlan,
    msisdn,
    DETAILS_FETCHED_SUCCESS,
    assurantIneligibleRepair,
    showTmoForBusiness,
  ]);

  return (
    <Modal
      displayLocaleSelection={true}
      showCloseButton={false}
      visible={showCustomerLookup}
    >
      <ContentsWrapper>
        <h1 className="title">{CONTENTS[modalContents].title}</h1>
        {React.createElement(CONTENTS[modalContents].component, {
          onConfirm: handleOnConfirm,
        })}
      </ContentsWrapper>
    </Modal>
  );
}

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 560px;
  text-align: center;

  ${down('md')} {
    max-width: 75vw;
  }

  .title {
    color: black;
    font-weight: 375;
    align-self: center;
    font-size: 2.2em;
  }
`;
